import { OrderProductsWithErrors } from '../../../../../services/modules/order-product/order-product.types';
import {
  GroupByColorClassificationTypeInfo,
  OrderProduct,
  Section,
} from '../../orderProducts.types';

export interface OrderProductsGroupProps {
  orderProducts: OrderProduct[];
  info?: GroupByColorClassificationTypeInfo;
  orderProductsWithErrors?: OrderProductsWithErrors;
}

abstract class OrderProductsGroupBuilder {
  public abstract group({
    orderProducts,
    info,
    orderProductsWithErrors,
  }: OrderProductsGroupProps): Section[];
}

export default OrderProductsGroupBuilder;
